// extracted by mini-css-extract-plugin
export default {"autoComplete":"MultiSelectStyles_autoComplete__qUVa8","addButton":"MultiSelectStyles_addButton__DEJv8","right":"MultiSelectStyles_right__nj1cE"};